import { d as n } from "../../vendor-CPVnY93G.js";
import "react/jsx-runtime";
import "react";
import { getSpacingClasses as m } from "../../utils/getSpacingClasses/index.js";
import '../../assets/index10.css';const g = "_baseButton_go8td_1", a = "_sm_go8td_28", i = "_md_go8td_33", p = "_primary_go8td_39", u = "_secondary_go8td_53", y = "_ghost_go8td_54", B = "_destructive_go8td_81", t = {
  baseButton: g,
  sm: a,
  md: i,
  primary: p,
  secondary: u,
  ghost: y,
  destructive: B
}, f = ({ size: o, variant: s, m: _, mt: d, mr: c, mb: r, ml: e }) => n(
  t.baseButton,
  o ? t[o] : void 0,
  s ? t[s] : void 0,
  m({ m: _, mb: r, ml: e, mr: c, mt: d })
);
export {
  f as getButtonStyles
};
